<template>
	<keep-alive>
		<div class="card-footer">
			<div class="footer-links ml-2">
				<button
					v-if="showMTransfer"
					@click.prevent.stop="showForm(2)"
					type="button"
					class="btn btn-secondary text-lowercase"
				>
					Zasil z mTransfer
				</button>
				<button
					v-if="showPaynow"
					@click.prevent.stop="showForm(4)"
					type="button"
					class="btn btn-secondary text-lowercase"
				>
					Zasil z paynow
				</button>
			</div>
		</div>
	</keep-alive>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	methods: {
		showForm(transferTypeId) {
			this.$store.commit('setFastPaymentType', transferTypeId);
			this.$store.commit('setDisplayFormFastPayment', true);
			this.$store.commit('setDisplayFormPayout', false);
			this.$store.commit('setDisplayFormAccounts', false);
		},
	},
	computed: {
		...mapGetters({
			showMTransfer: 'getShowMTransfer',
			showPaynow: 'getShowPaynow',
		}),
	},
};
</script>
